import LegalLayout from '../components/LegalLayout';
import { openCookiePreferences } from '../lib/consent';
import { COMPANY, LEGAL_UPDATED } from '../constants/legal';

const CookiesPage = () => (
  <LegalLayout
    testId="cookies-page"
    title="Cookie Policy — Politique de gestion des cookies"
    description="How Gate 33 uses cookies and tracking technologies. Manage your cookie preferences at any time."
    path="/legal/cookies"
    updated={LEGAL_UPDATED}
  >
    <p className="text-lg text-[#1A1A1A] leading-relaxed mb-8">
      This Cookie Policy explains what cookies are, how {COMPANY.tradingName} uses them, and how you can manage them. It complements our Privacy Policy and follows CNIL guidelines and the ePrivacy Directive.
    </p>

    <div className="my-8 p-6 bg-white border border-[#C5A880]">
      <p className="mb-4 text-[#0F0F0F]">
        <strong>Manage your preferences at any time.</strong> Non-essential cookies are disabled by default. You can change your choice below.
      </p>
      <button
        type="button"
        onClick={openCookiePreferences}
        data-testid="cookies-page-manage-btn"
        className="inline-flex items-center gap-2 bg-[#0F0F0F] text-[#FDFBF7] px-6 py-3 uppercase tracking-[0.15em] text-xs font-semibold hover:bg-[#C5A880] hover:text-[#0F0F0F] transition-all duration-300"
      >
        Manage cookie preferences
      </button>
    </div>

    <h2>1. What are cookies?</h2>
    <p>
      Cookies are small text files stored on your device (computer, phone, tablet) when you visit a website. They allow the site to recognise your browser and remember information about your visit, such as your language preference or authentication state.
    </p>

    <h2>2. Categories of cookies we use</h2>
    <h3>Essential cookies (always active)</h3>
    <p>Strictly necessary for the site to function. Cannot be disabled.</p>
    <ul>
      <li><strong>gate33_cookie_consent</strong> — stores your consent choices. Purpose: consent management. Retention: 6 months.</li>
      <li><strong>Session cookies</strong> — temporary cookies used for navigation. Purpose: technical. Retention: session.</li>
    </ul>

    <h3>Analytics cookies (off by default — require consent)</h3>
    <p>Help us understand how visitors use the site so we can improve it. Data is aggregated and anonymised.</p>
    <ul>
      <li><strong>Google Analytics 4 (_ga, _ga_*)</strong> — anonymised audience measurement. Provider: Google LLC. Retention: 13 months.</li>
    </ul>

    <h3>Marketing cookies (off by default — require consent)</h3>
    <p>Used to measure the effectiveness of our marketing campaigns and to display relevant content.</p>
    <ul>
      <li><strong>LinkedIn Insight Tag (li_sugr, bcookie, lidc, ...)</strong> — conversion tracking. Provider: LinkedIn Corporation. Retention: up to 2 years.</li>
      <li><strong>HubSpot (hubspotutk, __hstc, __hssc)</strong> — CRM tracking and chat widget. Provider: HubSpot, Inc. Retention: up to 13 months.</li>
      <li><strong>Meta Pixel (_fbp, fr)</strong> — advertising conversion tracking. Provider: Meta Platforms, Inc. Retention: up to 90 days.</li>
    </ul>

    <h2>3. How to manage cookies</h2>
    <p>You can:</p>
    <ul>
      <li>Use the "Manage cookie preferences" button above (or the cookie banner at the bottom of the site) to accept, refuse or customise cookie categories.</li>
      <li>Change your browser settings to block or delete cookies. Please note that disabling essential cookies may impair site functionality.</li>
      <li>Use browser-specific opt-outs: <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Chrome</a>, <a href="https://support.mozilla.org/kb/enhanced-tracking-protection-firefox-desktop" target="_blank" rel="noopener noreferrer">Firefox</a>, <a href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a>, <a href="https://support.microsoft.com/microsoft-edge" target="_blank" rel="noopener noreferrer">Edge</a>.</li>
    </ul>

    <h2>4. Consent duration</h2>
    <p>
      Your cookie consent choice is stored for up to 6 months, after which the cookie banner will reappear. You may withdraw your consent at any time via the "Manage cookie preferences" button.
    </p>

    <h2>5. Contact</h2>
    <p>
      For any question about our use of cookies, contact us at <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
    </p>
  </LegalLayout>
);

export default CookiesPage;
